export class LevelLine {
    constructor(name, level, color, width, style) {
        this.LineNumber = -1;
        this.Vector = null;
        this.Name = name;
        this.color = color;
        this.width = width;
        this.style = style;
        this.level = level;
    }
    get Level() {
        return this.level;
    }
    set Level(value) {
        this.level = value;
        if (this.Vector !== null) {
            this.Vector.Value = this.level;
        }
    }
}
